const CLASS_PREFIX = "exercise-list";
const DATA_PREFIX = "data-exercise-list";

export function exerciseList() {

}


